import { render, staticRenderFns } from "./TelcoCrearForm.vue?vue&type=template&id=58cb1bc4&"
import script from "./TelcoCrearForm.vue?vue&type=script&lang=ts&"
export * from "./TelcoCrearForm.vue?vue&type=script&lang=ts&"
import style0 from "./TelcoCrearForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports